import { FaCheckCircle } from "react-icons/fa";
import { Link } from 'react-router-dom';


const ConsultationOffer = () => {
  return (
    <section className="relative bg-gradient-to-l from-[#1B2435] to-black py-20 px-6 md:px-12 lg:px-20 text-white overflow-hidden">
      {/* Decorative gradient orbs */}
      <div className="absolute top-10 left-10 w-48 h-48 bg-yellow-400/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 right-10 w-64 h-64 bg-pink-500/10 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 items-center gap-16">
        {/* Left Side Content */}
        <div>
          <h2 className="text-4xl md:text-4xl font-extrabold leading-tight mb-6">
            Unlock a{" "}
            <span className="text-yellow-300"> $100 Consultation</span> - absolutely free!
          </h2>

          <p className="text-lg md:text-md text-gray-300 mb-8 leading-relaxed">
            No strings attached. Get personalized guidance from our experts to
            discover hidden opportunities and shape powerful digital strategies.
          </p>  

          {/* Key Benefits */}
          <ul className="space-y-4">
            {[
              "Tailored strategies aligned with your goals",
              "Expert insights on AI, cloud, and modern apps",
              "Practical recommendations you can apply instantly",
            ].map((benefit, index) => (
              <li key={index} className="flex items-start gap-3">
                <FaCheckCircle className="text-yellow-400 mt-1 flex-shrink-0" />
                <span className="text-gray-200">{benefit}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Side - CTA Card */}
        <div className="bg-white/5 backdrop-blur-lg border border-white/10 p-10 rounded-2xl shadow-xl text-center max-w-md w-full mx-auto">
          <h3 className="text-2xl font-semibold mb-4 text-white">
            Ready to Elevate Your Business?
          </h3>
          <p className="text-gray-300 mb-8 text-base">
            Book your free consultation today and take the first step toward
            smarter digital growth.
          </p>
            <Link
             to="/contact"
            >
          <button
            className="w-full px-8 py-4 rounded-xl font-bold text-lg 
                       text-white bg-gradient-to-r from-yellow-400 to-pink-500 
                       hover:from-yellow-500 hover:to-pink-600 
                       transition duration-500 ease-in-out 
                       transform hover:scale-105 shadow-lg"
                      
          >
            Book Your Consultation
          </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ConsultationOffer;
